import { Avatar, AvatarFallback, AvatarImage } from '@/app/shared/components';
/////////////////////////////////////////////////////////////
import { useCustomSelector } from '@/core/redux/hooks';

export const Username: React.FC = () => {
	/*********************
	// #region Redux
	**********************/
	const { username, firstName } = useCustomSelector(
		(state) => state.user.data
	);

	/*********************
	// #region Template
	**********************/
	return (
		<div className="flex items-center gap-2">
			<Avatar className="h-6 w-6">
				{process.env.VITE_PROFILE_IMAGE && (
					<AvatarImage
						className="drop-shadow-2xl"
						src={process.env.VITE_PROFILE_IMAGE}
					/>
				)}
				{username && (
					<AvatarFallback>
						{username.slice(0, 2).toUpperCase()}
					</AvatarFallback>
				)}
			</Avatar>
			{username && <div className="font-bold text-xs">{firstName}</div>}
		</div>
	);
};
